import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';
// import ReactDatePicker from '../../../ReactDatePicker/ReactDatePicker';

const TestimonialForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        image: editData?.image || '',
        title: editData?.title || '',
        message: editData?.message || '',
        // date: editData?.date || '',
        rating: editData?.rating || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };

    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Image' required />

                <ReactInput name='image' type='file' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Title' required />

                <ReactInput name='title' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Message' required />

                <ReactInput name='message' as='textarea' rows={6} />
            </Form.Group>

            {/* <Form.Group className='mt-3'>
                <FormLabel title='Date' required />

                <ReactInput name='date' />
            </Form.Group> */}

            {/* <Form.Group className='mt-3'>
                <FormLabel title='Date' required />
                <ReactDatePicker
                    value={initialValues?.date} // Bind the initial date value.
                    onChange={(val) => {
                        initialValues.date = val; // Update the date value.
                    }}
                />
            </Form.Group> */}

            <Form.Group className='mt-3'>
                <FormLabel title='Rating' required />

                <ReactInput name='rating' />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default TestimonialForm;
